// extracted by mini-css-extract-plugin
export default {"About":"About_About__g0Mpo","content":"About_content__0BcXE"};